import { RepairKitDeliveryIndicator } from './repair-kit-delivery'
import React from 'react'
import dayjs from 'dayjs'
import { Value } from '../../elements'
import { MobileField } from '../../../components/data-table/interface'

export const getMobileFields = (): MobileField[] => [
  {
    key: 'repair_kit_delivery',
    label: 'Ремкомплект',
    visible: record => Boolean(record?.repair_kit_delivery),
    render: value => <RepairKitDeliveryIndicator info={value} showText />,
  },
  {
    key: 'id',
    label: 'ID рекламации',
    render: val => <Value data={val} />,
  },
  {
    key: 'linked_card_id',
    label: 'ID обращения',
    visible: record =>
      Boolean(record?.linked_card_id) &&
      ['order', 'delivery'].includes(String(record?.linked_card_type)),
    labelRender: record => {
      if (record?.linked_card_type === 'order') {
        return 'ID заказа'
      }
      if (record?.linked_card_type === 'delivery') {
        return 'ID доставки'
      }
      return ''
    },
    render: val => <Value data={val} />,
  },
  {
    key: 'created_at',
    label: 'Дата рекламации',
    render: val => (val ? dayjs(val).format('DD.MM.YYYY') : <Value data={val} />),
  },
  {
    key: 'address',
    label: 'Адрес',
    render: val => <Value data={val} />,
  },
  {
    key: 'name',
    label: 'ФИО',
    render: val => <Value data={val} />,
  },
  {
    key: 'phone',
    label: 'Телефон',
  },
]
